export type CountryBadgeModel = {
  className?: string;
  flag: string;
  label: string;
  variant: 'blocked' | 'innovator' | 'outline' | 'warning';
};

export const getCountryBadgeModel = (jurisdiction: string): CountryBadgeModel => {
  if (jurisdiction === 'AU') {
    return {
      className: 'border-transparent bg-slate-200 text-slate-700',
      flag: '🇦🇺',
      label: 'AU',
      variant: 'warning',
    };
  }

  if (jurisdiction === 'US') {
    return {
      className: 'border-transparent bg-sky-100 text-sky-700',
      flag: '🇺🇸',
      label: 'US',
      variant: 'innovator',
    };
  }

  if (jurisdiction === 'UK') {
    return {
      flag: '🇬🇧',
      label: 'UK',
      variant: 'outline',
    };
  }

  return {
    flag: '🌐',
    label: jurisdiction || 'International',
    variant: 'outline',
  };
};
